import ProjectWorld, { createServerEvent, ProjectEventType } from "../ProjectWorld";
import type { BaseEvent, BaseProjectionResult, BaseEventInput, EventProcessor } from "@utilitydelta/clientside-event-sourcing";
import { ServerEvent } from "@utilitydelta/eventplanedb-client";

export const MINOR_VERSION: number = 1;

export interface AskedForSymmetricKey_LocalEvent extends BaseEvent<ProjectEventType> {
    tp: typeof ProjectEventType.AskedForSymmetricKey;
    publicKey: string; // Public key which can be used to encrypt the symmetric key
}

export interface AskedForSymmetricKey_ProjectionResult extends BaseProjectionResult {
    kind: 'AskedForSymmetricKey_ProjectionResult';
    publicKey: string; // Public key which can be used to encrypt the symmetric key
    projectId: string;
}

export interface AskedForSymmetricKey_EventInputs extends BaseEventInput {
    kind: 'AskedForSymmetricKey_EventInputs';
    publicKey: string; // Public key which can be used to encrypt the symmetric key
}

export type AskedForSymmetricKey_EventProcessorType = EventProcessor<ProjectEventType, AskedForSymmetricKey_EventInputs, AskedForSymmetricKey_LocalEvent, AskedForSymmetricKey_ProjectionResult, AskedForSymmetricKey_LocalEvent, ServerEvent<ProjectEventType>>;

export class AskedForSymmetricKey_EventProcessor implements AskedForSymmetricKey_EventProcessorType {

    private projectWorld: ProjectWorld;
    constructor(pw: ProjectWorld) { this.projectWorld = pw; }

    public get shouldEncrypt(): boolean { return false; }
    public get eventType(): ProjectEventType { return ProjectEventType.AskedForSymmetricKey; }
    public get eventTypeMinorVersion(): number { return MINOR_VERSION; }
    public get undoEventType(): ProjectEventType { return ProjectEventType.AskedForSymmetricKey; }
    public get undoEventTypeMinorVersion(): number { return MINOR_VERSION; }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public createUndoEvent = (_undoEvent: AskedForSymmetricKey_LocalEvent, _originalEventProjectionResult: AskedForSymmetricKey_ProjectionResult): boolean => {
        return false;
    }

    public projectOntoWorld = (event: AskedForSymmetricKey_LocalEvent, _addUpdatedEntitiesToDirtySet: boolean, returnProjectionResults: boolean): AskedForSymmetricKey_ProjectionResult | undefined => {
        return !returnProjectionResults ? undefined : {
            kind: 'AskedForSymmetricKey_ProjectionResult',
            publicKey: event.publicKey,
            projectId: this.projectWorld.projectMetadata.id
        };
    }

    public createLocalEvent = (eventToPopulate: AskedForSymmetricKey_LocalEvent, userInputs: AskedForSymmetricKey_EventInputs): boolean => {
        eventToPopulate.publicKey = userInputs.publicKey;

        return true;
    }

    public toServerEvent = async (localEvent: AskedForSymmetricKey_LocalEvent): Promise<ServerEvent<ProjectEventType>> => {
        const eventData = {
            publicKey: localEvent.publicKey,
        };
        const eventDataString = JSON.stringify(eventData);
        const serverEvent = createServerEvent(localEvent, eventDataString);
        return serverEvent;
    }

    public fromServerEvent = async (localEventToPopulate: AskedForSymmetricKey_LocalEvent, serverEvent: ServerEvent<ProjectEventType>): Promise<void> => {
        const eventData = JSON.parse(atob(serverEvent.ev))
        Object.assign(localEventToPopulate, eventData);
    }
}